const ROLE_LABELS = {
  author: "Автор",
  moderator: "Модератор",
};

const PACKAGE_LABELS = {
  small: "10 ключей",
  medium: "25 ключей",
  big: "50 ключей",
};

export function getUserRoleLabel(type) {
  return ROLE_LABELS[type] ?? "Автор";
}

export function getPaymentPackageLabel(packageSize) {
  if (!packageSize) return "Пакет ключей";
  return PACKAGE_LABELS[packageSize] ?? "Пакет ключей";
}

export function formatPaymentPrice(price) {
  if (price == null || price === "") return "—";

  const numeric = Number(String(price).replace(",", "."));
  if (Number.isNaN(numeric)) return `${price} ₽`;

  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 0,
  }).format(numeric);
}
